import { validators } from '../../utils/validators';

const validate = values => {
    const { REQUIRED } = validators;
    const errors = {};
    if (REQUIRED(values.otp) || (values.otp && values.otp.length !== 6)) {
        errors.otp = 'Please enter your OTP number';
    }
    return errors;
};

export default validate;
